<template>
    <div>
        <div class="col-sm-12">
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.titleLPforPrize') }}</label>
                <div class="col-sm-10">
                    {{ dataForm.prize_settings.title }}
                    <div class="mt-3">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                            <div class="col-sm-3">
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    {{ `${dataForm.prize_settings.size_title}px` }}
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                            <div class="col-sm-3">
                                <InputText
                                    style="max-width: 100px"
                                    :model.sync="dataForm.prize_settings.color_title"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    disabled
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-3">
                                <InputText
                                    style="max-width: 100px"
                                    :model.sync="dataForm.prize_settings.background_title"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.imgTitleLPforPrize') }}</label>
                <div class="col-sm-10">
                    <div v-if="dataForm.prize_settings.title_image?.path" style="width: 200px; height: 200px" class="position-relative">
                        <b-img
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.prize_settings.title_image?.path"
                            :alt="dataForm.prize_settings.title_image.origin_name"
                            style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                        ></b-img>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.background') }}</label>
                <div class="col-sm-10">
                    <div>
                        <div v-if="dataForm.prize_settings.background.image?.path" style="width: 200px; height: 200px" class="position-relative">
                            <b-img
                                class=""
                                thumbnail
                                fluid
                                :src="dataForm.prize_settings.background.image?.path"
                                :alt="dataForm.prize_settings.background.image.origin_name"
                                style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                            ></b-img>
                        </div>
                    </div>
                    <div class="my-3">
                        <InputText
                            style="max-width: 100px"
                            :model.sync="dataForm.prize_settings.background.color"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                            :disabled="true"
                        />
                    </div>
                    <div>
                        <InputCheckBox
                            :model.sync="dataForm.prize_settings.is_repeat"
                            :id="`check-repeat-background-prize_lp`"
                            :value="dataForm.prize_settings.is_repeat"
                            :label="`repeat`"
                            :disabled="true"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.selectedStyle') }} </label>
                <div class="col-sm-10">
                    <div style="width: 100px; height: 80px">
                        <img
                            class="w-100 h-100"
                            style="object-fit: cover"
                            :src="dataForm.prize_settings.style?.image_preview"
                            :alt="dataForm.prize_settings.style?.image_preview"
                        />
                    </div>
                    <div class="mt-3 body__preview">
                        <div
                            class="block_prizes"
                            :style="`background-color: ${dataForm.prize_settings.background.color ?? ''};
                                    background-image: url(${dataForm.prize_settings.background.image?.path});
                                    background-repeat: ${dataForm.prize_settings.is_repeat ? 'repeat' : 'no-repeat'};`"
                        >
                            <div :class="`box--prize__${dataForm.prize_settings.style?.id}`">
                                <div v-if="dataForm.prize_settings.title_image?.path" class="mb-5">
                                    <img
                                        :src="dataForm.prize_settings.title_image.path"
                                        :alt="dataForm.prize_settings.title_image.path"
                                        class="img__title"
                                    />
                                </div>

                                <div style="padding-block: 5rem" v-else>
                                    <h2
                                        v-if="STYLE_SHOW_TITLE.includes(dataForm.prize_settings.style?.id)"
                                        class="title-common"
                                        :style="`background: ${dataForm.prize_settings.background_title ?? ''};
                                            color:  ${dataForm.prize_settings.color_title ?? ''};
                                            font-size: ${dataForm.prize_settings.size_title}px;`"
                                    >
                                        <span>{{ dataForm.prize_settings?.title }}</span>
                                    </h2>
                                    <h2 v-else class="title-common">
                                        <div
                                            class="title-eng"
                                            :style="`background: ${dataForm.prize_settings.background_title ?? ''};
                                                color:  ${dataForm.prize_settings.color_title ?? ''};
                                                font-size: ${dataForm.prize_settings.size_title}px;`"
                                        >
                                            <span>{{ dataForm.prize_settings?.title }}</span>
                                        </div>
                                        <!-- <div class="title-jp"></div> -->
                                    </h2>
                                </div>
                                <div class="list__prize" v-html="dataForm.prize_settings.html_content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputCheckBox, InputText } from '@/components/Input';
import { STYLE_SHOW_TITLE } from '../../../constants';

export default {
    name: 'SettingPrizeList',
    components: {
        InputCheckBox,
        InputText
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            STYLE_SHOW_TITLE: STYLE_SHOW_TITLE
        };
    },

    methods: {},
    watch: {},
    mounted() {}
};
</script>

<style lang="scss" scoped></style>
